import {Alarm} from './types'
import type {FilterConfig} from '../components/filters/types'
import {Search, Get, Post, Put} from './server'

export const getAlarms = async (query: FilterConfig) => Search('/alarm', query)
export const getAlarm = async (alarmId: string) => Get('/alarm', {id: alarmId})
export const setSubscription = async (alarmId: string, isSubscribed: boolean) =>
  Put('/alarm', {id: alarmId, isSubscribed})
export const updateAlarm = async (alarm: Alarm) => Put('/alarm', alarm)
export const createAlarm = async (a: Alarm) => Post('/alarm', a)
